import { useContext } from "react";
import { SimulatedCostStateContext } from "../SimulationProvider";

export const useSimulatedCostState = () => {
  const state = useContext(SimulatedCostStateContext);
  return state;
};
